import React, {useEffect, useState, useCallback} from "react";
import $ from 'jquery';
import {useNavigate, Link} from "react-router-dom";
import {useSelector} from "react-redux";
import swal from 'sweetalert';
import axios from "axios";
import _ from "lodash";
import "../../assets/css/pages/advertisements.css";
import {confirmAlert} from "../../Components/Alerts/BasicAlert";

export default function () {
  const navigate = useNavigate();
  const token = useSelector(state => state.token);
  const [bulkArray, setBulkArray] = useState([]);
  const buttonIsDisabled = !bulkArray.length;
  const filterInitialValues = {
    id: "",
    name: "",
    shop: "",
    published: "",
  }

  const user = useSelector(state => state.user);
  const isAdmin = user?.roles?.includes('Super Admin');
  const isSeller = user?.roles?.includes('Seller');

  const [filterParams, setFilterParams] = useState(filterInitialValues);

  const deleteRow = (table, selector) => {
    table
      .row(selector.parents('tr'))
      .remove()
      .draw(false);
  }

  useEffect(() => {
    triggerDatatable();
  }, []);

  const triggerFilter = (e) => {
    e.preventDefault();
    localStorage.removeItem("DataTables_advertisements_/advertisements");
    triggerDatatable();
  }

  const triggerDatatable = (resetFilter = false) => {
    let table = $('#advertisements').DataTable({
      "ajax": {
        url: process.env.REACT_APP_API_URL + "advertisements",
        method: 'GET',
        data: resetFilter ? {} : filterParams,
        beforeSend: function (request) {
          request.setRequestHeader("Authorization", 'Bearer ' + token);
        },
        error: function (xhr) {
          if (xhr?.status === 401) {
            axios.defaults.baseURL = process.env.REACT_APP_API_CLEAN_URL;
            axios.post('/logout')
              .then(
                localStorage.removeItem('persist:root'),
                navigate('/login')
              );
          }
        }
      },
      "destroy": true,
      "columns": [
        {
          data: 'checkbox',
          searchable: false,
          orderable: false,
          render: function (data, type, row) {
            return `
                    <label class="form-label-checkbox fs-6 fw-bolder text-dark">
                      <input class="checkbox list" type="checkbox" label="My Value" name="primary" row-id="${row.id}">
                      <span class="checkmark"></span>
                    </label>`;
          },
        },
        {data: 'id', name: 'id'},
        {
          data: 'name',
          searchable: false,
          orderable: true,
          render: function (data, type, row) {
            return `<div class="ellipsis" title="${row?.name}">${row?.name}</div>`;
          },
        },
        {data: 'shop.name', name: 'shop.name', defaultContent: ''},
        {
          data: 'start_date',
          searchable: false,
          orderable: true,
          render: function (data, type, row) {
            return new Date(row?.start_date).toLocaleDateString('en-GB');
          },
        },
        {
          data: 'end_date',
          searchable: false,
          orderable: true,
          render: function (data, type, row) {
            return new Date(row?.end_date).toLocaleDateString('en-GB');
          },
        },
        {
          data: 'published', name: 'published', orderable: true, searchable: false,
          render: function (data, type, row) {
            return `<div class="p-3 fs-8 text-center text-white rounded ${row?.published ? "bg-success" : "bg-danger"}"
                         row-id="${row?.id} row-name="${row?.name}">
                               ${row?.published ? "Published" : "Unpublished"}
                            </div>`;
          }
        },
        {
          data: 'created_at',
          searchable: false,
          orderable: true,
          render: function (data, type, row) {
            return new Date(row?.created_at).toLocaleDateString('en-GB');
          },
        },
        {
          data: 'actions',
          searchable: false,
          orderable: false,
          render: function (data, type, row) {
            return `
                    <button type="button"
                        class="btn-primary me-2 mb-2 actions">
                            Actions
                            <i class="fas fa-caret-down"></i>
                    </button>
                    <div class="row-actions display-none hidden-actions">
                        <div class="absolute-div">
                            <button 
                            class="btn btn-primary me-2 mb-4 mt-1 edit"
                            row-id="${row.id}" row-name="${row.name}">
                                <i class="fas fa-edit"></i> Edit
                            </button>

                            ${isAdmin ?
              (row?.published ?
                `<button
                                class="btn btn-danger me-2 mb-4 mt-1 unpublish"
                                row-id="${row.id}" row-name="${row.name}">
                                    <i class="far fa-times-circle"></i> Unpublish
                                </button>` :
                `<button
                                class="btn btn-success me-2 mb-4 mt-1 publish"
                                row-id="${row.id}" row-name="${row.name}">
                                    <i class="far fa-arrow-alt-circle-up"></i> Publish
                            </button>`)
              : ``}

                            <button 
                            class="btn btn-danger me-2 mb-1 delete"
                            row-id="${row.id}" row-name="${row.name}">
                                <i class="far fa-trash-alt"></i> Delete
                            </button>
                        <div>
                    </div>
                    `;
          },
        }
      ],
      "order": [[0, "desc"]],
    });

    table.off('click');

    table.on('click', 'button.actions', function () {
      if ($(this).next(".row-actions").hasClass("hidden-actions")) {
        $(this).next(".row-actions").fadeIn(100).removeClass("hidden-actions");
      } else {
        $(this).next(".row-actions").fadeOut(100).addClass("hidden-actions");
      }
    });

    table.on('click', 'button.delete', function () {
      const id = ($(this).attr("row-id"));
      const name = ($(this).attr("row-name"));
      $(".row-actions").fadeOut(100).addClass("hidden-actions");
      deleteAdvertisement(id, name, table, $(this));
    });

    table.on('click', 'button.edit', function () {
      const id = ($(this).attr("row-id"));
      navigate('/advertisements/' + id + '/edit');
    });

    table.on('click', 'button.publish', function () {
      const id = ($(this).attr("row-id"));
      updatePublishStatus(id, true, table);
    });

    table.on('click', 'button.unpublish', function () {
      const id = ($(this).attr("row-id"));
      updatePublishStatus(id, false, table);
    });

    $("<span class='table-filter-icon br-0-95-rem' title='Filter'><i class='fa fa-filter fs-4 br-1000'></i>Filter</span>")
      .insertAfter("#advertisements_length label");

    $(".table-filter-icon").click(function () {
      $(".toggle-filter").slideToggle(100);

      let condition = $(".table-filter-icon i").hasClass("fa-filter");

      $(".table-filter-icon")
        .html(condition ? "<i class='far fa-times-circle fs-4 br-1000'></i>Close"
          : "<i class='fa fa-filter fs-4 br-1000'></i>Filter");
    });

    let datatableSearch = ".dataTables_wrapper .dataTables_filter input[type=search]";
    $("<i class='fas fa-search'></i>")
      .insertBefore(datatableSearch);
    $(datatableSearch)
      .attr("placeholder", "Search...");

    table.on('click', '.form-label-checkbox .checkbox', function () {
      const id = ($(this).attr("row-id"));
      setBulkArray(cur => _.xor(cur, [id]));
    });

    $('.toggle-filter').each(function () {
      if ($(this).css('display') == 'block') {
        $(".table-filter-icon").html("<i class='far fa-times-circle fs-4 br-1000'></i>Close");
      }
    });

    table.on('click', '.form-label-checkbox .checkbox.mark-all', function () {
      if ($(this).is(':checked')) {
        setBulkArray([]);
        let allId = [];
        $(".form-label-checkbox .checkbox.list").each(function (index) {
          if ($(this).is(':checked') == false) {
            $(this).click();
          }
          allId.push($(this).attr("row-id"));
        });
        setBulkArray(allId);
      } else {
        $(".form-label-checkbox .checkbox.list").each(function (index) {
          if ($(this).is(':checked') == true) {
            $(this).click();
          }
        });
        setBulkArray([]);
      }
    });

    table.on('draw', function () {
      $(".pagination .page-item").click(function () {
        resetMarked();
      });
      resetMarked();
      $(".form-label-checkbox #mark-all").click().click();
    });

    $("table.dataTable thead tr:first-child th:nth-child(1)")
      .html(`<label class="form-label-checkbox form-label-checkbox-mark-all  fs-6 fw-bolder text-dark pt-0">
           <input class="checkbox mark-all" type="checkbox" id="mark-all" label="My Value" name="primary">
           <span class="checkmark"><span></span></span>
           </label>`);

  }

  const resetMarked = () => {
    if ($(".form-label-checkbox .checkbox.mark-all").is(":checked")) {
      $(".form-label-checkbox .checkbox.mark-all").click();
    }
    $(".form-label-checkbox .checkbox.list").each(function (index) {
      if ($(this).is(':checked') == true) {
        $(this).click();
      }
    });
    setBulkArray([]);
  }

  const updatePublishStatus = (id, status, table) => {
    swal({
      title: "Are you sure?",
      text: `You want to ${status ? "publish" : "unpublish"} this advertisement?`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
      confirm: {
        text: "Yes",
        value: true,
        visible: true,
        className: "",
        closeModal: true
      }
    }).then((result) => {
      if (result == true) {
        axios.post(`/advertisements/${id}/publish`,
          {published: status})
          .then((res) => {
            swal(`Advertisement has been ${status ? "published" : "unpublished"}!`, {
              icon: "success",
            });
            table.draw(false);
            return true;
          }).catch(errors => {
          console.log(errors)
        });
      }
    });
  }

  const deleteAdvertisement = (id, name, table, selector) => {
    confirmAlert('You want to delete advertisement "' + name + '"?', () => {
      axios.delete('advertisements/' + id).then(res => {
        deleteRow(table, selector);
      });
    });
  }

  const bulkUpdatePublish = (publishStatus) => {
    swal({
      title: "Are you sure?",
      text: `You want to ${publishStatus ? "publish" : "unpublish"} marked advertisements?`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
      confirm: {
        text: "Yes",
        value: true,
        visible: true,
        className: "",
        closeModal: true
      }
    }).then((result) => {
      if (result == true) {
        axios.post("advertisements/bulk-publish",
          {advertisements: bulkArray, publish: publishStatus})
          .then((res) => {
            if (res.status == 200) {
              swal(`Advertisements has been ${publishStatus ? "published" : "unpublished"}!`, {
                icon: "success",
              });

              resetMarked();
              $('#advertisements').DataTable().draw(false);
              return true;
            }
          }).catch(errors => {
          console.log(errors)
        });
      }
    });
  }

  const bulkDeleteAdvertisement = () => {
    swal({
      title: "Are you sure?",
      text: `You want to delete marked advertisements?`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
      confirm: {
        text: "Yes",
        value: true,
        visible: true,
        className: "",
        closeModal: true
      }
    }).then((result) => {
      if (result == true) {
        axios.post('advertisements/bulk-destroy', {
          advertisements: bulkArray,
        })
          .then(function (res) {
            if (res.status == 200) {
              swal(`Advertisements has been deleted successfully!`, {
                icon: "success",
              });

              resetMarked();
              $('#advertisements').DataTable().draw(false);
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.data.errors);
            }
          });
      }
    });
  }

  const resetFilter = () => {
    setFilterParams(filterInitialValues);
    localStorage.removeItem("DataTables_advertisements_/advertisements");
    triggerDatatable(true);
  }

  return (
    <>
      <div>
        <div className="toggle-filter display-none">
          <form onSubmit={triggerFilter} className="row">

            <div className="fv-row mb-10 col-xxl-2 col-lg-6">
              <label className="form-label fs-6 fw-bolder color-dark-grey">ID</label>
              <input className="form-control form-control-lg form-control-solid"
                     type="text"
                     name="id"
                     onChange={(e) => setFilterParams({
                       ...filterParams,
                       id: e.target.value
                     })}
                     value={filterParams.id}
              />
            </div>
            <div className="fv-row mb-10 col-xxl-3 col-lg-6">
              <label className="form-label fs-6 fw-bolder color-dark-grey">Name</label>
              <input className="form-control form-control-lg form-control-solid"
                     type="text"
                     name="name"
                     onChange={(e) => setFilterParams({
                       ...filterParams,
                       name: e.target.value
                     })}
                     value={filterParams.name}
              />
            </div>
            <div className="fv-row mb-10 col-xxl-2 col-lg-6">
              <label className="form-label fs-6 fw-bolder color-dark-grey">Shop</label>
              <input className="form-control form-control-lg form-control-solid"
                     type="text"
                     name="shop"
                     onChange={(e) => setFilterParams({
                       ...filterParams,
                       shop: e.target.value
                     })}
                     value={filterParams.shop}
              />
            </div>
            <div className="fv-row mb-10 col-xxl-2 col-lg-6">
              <label className="form-label fs-6 fw-bolder color-dark-grey">Published</label>
              <select
                className="form-control form-control-lg form-control-solid"
                onChange={(e) => setFilterParams({
                  ...filterParams,
                  published: parseInt(e.target.value)
                })}
                title="Change Chart"
                value={filterParams.published}
              >
                <option value="">--Published status--</option>
                <option value="1">Only published</option>
                <option value="2">Only unpublished</option>
              </select>
            </div>

            <div className="col-xxl-3 col-lg-12 text-xxl-end pt-8">
              <button
                className="btn btn-primary py-4"
                title="Filter Table"
                type="submit"
                onClick={triggerFilter}
              >
                <i className="fas fa-sync-alt fs-5 mr-2"></i>
                Filter
              </button>
              <button
                type="button"
                className="btn btn-lg btn-primary clear-filter ml-2 py-4 px-5"
                title="Clear Filter"
                onClick={resetFilter}
              >
                  <span className="indicator-label clear-filter-icon">
                    <i className="fa fa-times-circle fs-3 display-contents"></i>
                  </span>
                <span className="clear-filter-text">Clear</span>
              </button>
            </div>
          </form>
        </div>
        <div className="text-right pb-3">
          <div className={`marked-actions d-inline-block ${buttonIsDisabled ? " d-none" : ""}`}>
            <span className="d-inline-block border-end pr-3 mr-3">
            {
              isAdmin &&
              <>
                <button
                  type="button"
                  className="btn btn-success mr-3"
                  onClick={() => bulkUpdatePublish(true)}
                  disabled={buttonIsDisabled}
                >
                  <i className="far fa-arrow-alt-circle-up fs-5 mr-2"></i> Publish
                </button>
                <button
                  type="button"
                  className="btn btn-danger mr-3"
                  onClick={() => bulkUpdatePublish(false)}
                  disabled={buttonIsDisabled}
                >
                  <i className="far fa-times-circle fs-5 mr-2"></i> Unpublish
                </button>
              </>
            }
              <button
                type="button"
                className="btn btn-danger br-12-5-px w-10-rem"
                onClick={() => bulkDeleteAdvertisement()}
                disabled={buttonIsDisabled}
              >
                <i className="far fa-trash-alt fs-5 mr-2"></i> Delete
              </button>
            </span>
          </div>
          <button type="button"
                  className="btn btn-primary br-12-5-px mr-3"
                  data-bs-toggle="tooltip"
                  title="Coming Soon"
                  onClick={() => {
                    navigate('/advertisements/create');
                  }}
          >
            <i className="fas fa-plus-circle fs-5 mr-2"></i>
            Add Advertisement
          </button>
        </div>
        <table id="advertisements" className="table align-middle table-row-dashed fs-6 gy-5">
          <thead>
          <tr className="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
            <th></th>
            <th>ID</th>
            <th>Name</th>
            <th>Shop</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Publish</th>
            <th>Create Date</th>
            <th>Actions</th>
          </tr>
          </thead>
          <tbody className="text-gray-600 fw-bold"></tbody>
        </table>
      </div>
    </>
  );
}